var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13 19.6944H5.42778C3.96541 19.6944 3.23424 19.6944 2.67569 19.4098C2.18437 19.1595 1.78493 18.76 1.5346 18.2687C1.25 17.7102 1.25 16.979 1.25 15.5166V5.5944C1.25 4.13205 1.25 3.40086 1.5346 2.84232C1.78493 2.351 2.18437 1.95155 2.67569 1.70122C3.23424 1.41663 3.96542 1.41663 5.42778 1.41663H20.5722C22.0346 1.41663 22.7658 1.41663 23.3243 1.70122C23.8156 1.95155 24.2151 2.351 24.4654 2.84232C24.75 3.40086 24.75 4.13205 24.75 5.5944V13.1666M1.25 6.63885H24.75M24.75 18.3898L18.2222 18.3888",
    style: {
      stroke: "var(--color, currentColor)"
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.6ef109d5.svg";
export { ForwardRef as ReactComponent };